/* eslint-disable */
import { useState, useMemo, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import axios from "axios";

export default function QuillEditor({ data, setData, pay, type }) {
  const editorRef = useRef();
  const [value, setValue] = useState(undefined);
  useEffect(() => {
    if (type === "pay") {
      setValue(data.texting.pay);
    }
    if (type === "return") {
      setValue(data.texting.return);
    }
    if (type === "thanks") {
      setValue(data.texting.return);
    }
  }, [type]);

  const onChange = (content, delta, source, editor) => {
    type === "pay" &&
      setData({ ...data, texting: { ...data.texting, pay: editor.getHTML() } });
    type === "return" &&
      setData({
        ...data,
        texting: { ...data.texting, return: editor.getHTML() },
      });
    type === "thanks" &&
      setData({
        ...data,
        texting: { ...data.texting, thanks: editor.getHTML() },
      });
  };

  const uploadImage2 = async (file) => {
    const dataImage = new FormData();
    dataImage.append("upload", file, file.name);
    axios
      .post(`https://octopus-app-i4ylg.ondigitalocean.app/upload`, dataImage, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then(function (response) {
        const editor = editorRef.current.getEditor();
        editor.insertEmbed(editor.getSelection(), "image", response.data.url);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  const imageHandler = async (e) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];

      // file type is only image.
      if (/^image\//.test(file.type)) {
        uploadImage2(file);
      } else {
        console.warn("You could only upload images.");
      }
    };
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" },
          ],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
          ["clean"],
          [{ color: [] }, { background: [] }],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
    "background",
    "align",
  ];

  return (
    <>
      {type === "pay" && (
        <ReactQuill
          theme="snow"
          value={data.texting.pay}
          modules={modules}
          ref={editorRef}
          formats={formats}
          onChange={onChange}
        />
      )}
      {type === "return" && (
        <ReactQuill
          theme="snow"
          value={data.texting.return}
          modules={modules}
          ref={editorRef}
          formats={formats}
          onChange={onChange}
        />
      )}
      {type === "thanks" && (
        <ReactQuill
          theme="snow"
          value={data.texting.thanks}
          modules={modules}
          ref={editorRef}
          formats={formats}
          onChange={onChange}
        />
      )}
    </>
  );
}
